import { prefix } from "."
import ShoppingCartIcon from "../svg/ShoppingCartIcon"
import { formatCurrency, plus } from "@/utils";
import { IShoppingCartInfo } from "@/types/order-types";
import { TFunction } from "i18next";

interface IShoppingCartBarProps {
  t: TFunction<"common", undefined>;
  shoppingCartData: IShoppingCartInfo | undefined;
  showShoppingCartPopup: boolean;
  handleCheckout: () => void;
  setShowShoppingCartPopup: (value: boolean) => void;
}

const ShoppingCartBar: React.FC<IShoppingCartBarProps> = (props) => {
  const { shoppingCartData, t, showShoppingCartPopup, setShowShoppingCartPopup, handleCheckout } = props;
  const { favoriteIdLineItemRef = {} } = shoppingCartData || {};

  let price = 0;
  let totalQuanity = 0;
  Object.values(favoriteIdLineItemRef).forEach(item => {
    const { quantity = 0, total = '0' } = item;
    totalQuanity = plus(totalQuanity, quantity);
    if (!isNaN(Number(total))) {
      price = plus(price, Number(total), 2);
    };
  })

  return (
    <div className={`${prefix}`}>
      <div className={`${prefix}-content`}>
        <div className={`${prefix}-content-left`}>
          <div className={`${prefix}-icon`}>
            <div className={`${prefix}-icon-quanity`}>{totalQuanity}</div>
            <ShoppingCartIcon onClick={() => setShowShoppingCartPopup(!showShoppingCartPopup)} />
          </div>
          <div className={`${prefix}-total`}>
            {formatCurrency(Number(price))}
          </div>
        </div>
        <div className={`${prefix}-content-right ${totalQuanity < 1 ? 'disabled' : ''}`} onClick={() => totalQuanity > 0 && handleCheckout()}>{t('checkout')}</div>
      </div>
    </div>
  )
}

export default ShoppingCartBar